<template>
  <div class="sg-confirm-order">
    <div class="main-con">
      <div class="bg-10px"></div>
      <div class="addr-con">
        <div class="no-addr" v-if="!addressSelectedId" @click="goAddressList">
          <div class="left-con">
            <span class="addr-icon"></span>
            <span>添加收货地址</span>
          </div>
          <div class="right-con"><span class="icon"></span></div>
        </div>
        <div class="has-addr" v-else @click="goAddressList">
          <div class="right-icon-con">
            <span class="icon"></span>
          </div>
          <div class="addr-info">
            <div class="name-con">
              <span class="name">{{ address.addresseeName }}</span>
              <span class="phone">{{ address.addresseeTel }}</span>
              <span class="default" v-if="address.isDefault">默认</span>
            </div>
            <div class="address">{{ address.fullArea +  address.detailAddress }}</div>
          </div>
          <div class="right-con"><span class="icon"></span></div>
        </div>
      </div>
      <div class="bg-10px"></div>
      <div class="">
        <confirm-order-item
            v-for="(item, i) in list"
            :key="item.shopId"
            :itemData="item"
            :shopKey="i"
            @openGoodsListCon="openGoodsListCon"
        ></confirm-order-item>
      </div>
      <div class="express-service">
        <div class="left-con">
          <div class="title">配送方式</div>
          <div class="text">京东快递</div>
        </div>
        <div class="right-con"><span class="icon"></span></div>
      </div>
      <div class="express-service-time">
        <div class="left-con" @click="openJDCalendar">
          <div class="title">配送时间</div>
          <div class="text-con vv-" v-if="small.length>0 && large.length>0">
            <div class="text time" v-if="small.length>0" v-html="'中小件货：'+showCalendarSelectText"></div>

            <div class="text date" v-if="lgDateList.length>0" v-html="'大件货：' + lgDateList[lgDateActive].text"></div>
            <div class="text date" v-if="lgDateList.length===0">大件货：工作日、双休日与节假日均可送货</div>
          </div>

          <div class="text-con v-else" v-else>
            <div class="text time" v-if="small.length>0" v-html="showCalendarSelectText"></div>

            <div class="text date" v-if="large.length>0 && lgDateList.length>0" v-html="lgDateList[lgDateActive].text"></div>
            <div class="text date" v-if="large.length>0 && lgDateList.length===0">工作日、双休日与节假日均可送货</div>

          </div>
        </div>
        <div class="right-con"><span class="icon"></span></div>
      </div>

      <div class="bg-10px"></div>

      <div class="deduct-coin">
        <div class="left">金币抵扣</div>
        <div class="can-deduct">可抵 {{ sgOrderTotalDeductionCoin }}</div>
        <div class="has-coin-con">
          <span class="text-item">已有金币: {{ antWallet.availableAmount }}</span>
          <span class="text-item" v-if="antWallet.availableAmount<Pcoin.goldMinDeduct">满 {{ Pcoin.goldMinDeduct }} 可用</span>
        </div>
        <div class="right">
          <van-switch size="22" v-model="isDeduct" :disabled="antWallet.availableAmount<Pcoin.goldMinDeduct" />
        </div>
      </div>

      <div class="bg-10px"></div>

      <div class="cell-list">
        <div class="cell">
          <div class="left">商品总价</div>
          <div class="right">{{ sgOrderTotalPrice>0 ? ('￥' + sgOrderTotalPrice.toFixed(2)) : '0' }}</div>
        </div>
        <div class="cell">
          <div class="left">运费</div>
          <div class="right"><span>{{ sgOrderFreight>0 ? ('+ ￥' + sgOrderFreight.toFixed(2)) : '免运费' }}</span></div>
        </div>
        <div class="cell" v-if="isDeduct">
          <div class="left">金币抵扣</div>
          <div class="right"><span>-￥{{ deductionPrice }}</span></div>
        </div>
      </div>
      <div class="bg-10px"></div>
    </div>


    <div class="bottom-con">
      <div class="goods-count">
        <div class="count">共{{ sgOrderGoodsCount }}件</div>
      </div>
      <div class="price-con">
        <div class="price">合计：<span class="red">￥<span class="big">{{ totalPrice }}</span></span></div>
      </div>
      <div class="btn-con">
        <div class="btn" @click="submitOrder">提交订单</div>
      </div>
    </div>


    <!--无货-->
    <van-popup
      class="not-goods-show"
      v-model="notGoodsShow"
      round
      :lazy-render="true"
      :close-on-click-overlay="false"
      :style="{width: '285px',height: '308px'}"
    >
      <div class="text">抱歉，您本单购买的以下商品无货！</div>
      <div class="list-con">
        <div class="list" v-for="(item, i) in notGoods" :key="i">
          <div class="img-con">
            <img class="img" :src="'http://img13.360buyimg.com/n2/'+item.mapProductDetail.coverImage" alt="">
            <div class="no-goods"></div>
          </div>
          <div class="info-con">
            <div class="title">{{ item.mapProductDetail.title }}</div>
            <div class="info-bottom">
              <div class="price-con">
                <span class="now-price">￥{{ item.mapPrice.sellPrice.toFixed(2) }}</span>
                <span class="old-price"><s>京东:￥{{ item.mapPrice.displayOriginalPrice.toFixed(2) }}</s></span>
              </div>
              <div class="count">x{{ item.productCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-con">
        <div class="btn cancel" @click="goAddressList">更换地址</div>
        <div class="btn go-setting" @click="goPrevPage">返回重新选择</div>
      </div>
    </van-popup>

    <!--无地址-->
    <van-popup
      class="not-address"
      v-model="notAddress"
      round
      :lazy-render="true"
      :close-on-click-overlay="false"
    >
      <div class="text">您还没有收货地址哦，赶快去设置一个吧！</div>
      <div class="btn-con">
        <div class="btn cancel" @click="goPrevPage">取消</div>
        <div class="btn go-setting" @click="goSettingAddress">设置</div>
      </div>
    </van-popup>

    <!--多个商品-列表-->
    <van-popup
        class="popup-goods-list-con"
        v-model="goodsListShow"
        round
        position="bottom"
        closeable
        close-icon="close"
        :lazy-render="true"
        :style="{ height: '80%' }"
    >
      <div class="header-con">
        <div class="header-title">商品清单</div>
        <div class="count" v-if="goodsNumberCount">共 {{ goodsNumberCount }} 件</div>
      </div>
      <div class="list-body">
        <goods-list v-for="(item2, i2) in shopItems" :item2="item2" :key="i2"></goods-list>
      </div>
    </van-popup>

    <!--同时存在大件货与小件货-->
    <van-popup
        class="popup-express-service-con"
        v-model="calendarShow"
        round
        position="bottom"
        closeable
        close-icon="close"
        :lazy-render="true"
        :style="{ height: '80%' }"
    >
      <div class="header-con">
        <div class="header-title">配送1</div>
        <div class="express-con">
          <span class="express">京东快递</span>
        </div>
      </div>
      <div class="date-con-body">
        <div class="list" @click="openCalendar(1)">
          <div class="title">中小件送货时间</div>
          <div class="date-text" v-if="small.length>0" v-html="showCalendarSelectText"></div>
        </div>
        <div class="list" @click="openCalendar(2)">
          <div class="title">大件送货时间</div>
          <div class="date-text" v-if="lgDateList.length>0" v-html="lgDateList[lgDateActive].text"></div>
          <div class="date-text" v-if="lgDateList.length===0">工作日、双休日与节假日均可送货</div>
        </div>
      </div>
      <div class="calendar-bottom">
        <div class="btn" @click="calendarShow=false">确定</div>
      </div>
    </van-popup>

    <!--中小件货-选日期+时间段-->
    <van-popup
        class="popup-express-service-con"
        v-model="calendarSmallShow"
        round
        position="bottom"
        closeable
        close-icon="close"
        :lazy-render="true"
        :style="{ height: '80%' }"
    >
      <div class="header-con">
        <div class="header-title">配送</div>
        <div class="express-con">
          <span class="express">京东快递</span>
        </div>
      </div>
      <div class="sub-header-con">
        <div class="sub-header-title">送货时间</div>
        <div class="express-time-con">
          <span class="express-time">标准达</span>
        </div>
      </div>
      <div class="calendar-body">
        <div class="date-con">
          <div class="date-item-con">
            <div class="item"
                 v-for="(item, i) in calendarList"
                 :class="{'active': (i===calendarSelectDate)}"
                 @click="selectDate(item, i)"
            >{{ item.dateStr }}</div>
          </div>
        </div>
        <div class="time-con">
          <div class="time-item-con">
            <div class="item"
                 v-for="(item2, i2) in calendarTimeList"
                 :class="{'active': (i2===calendarSelectDateTime)}"
                 @click="selectDateTime(item2, i2)"
            >{{ item2.timeRange }}</div>
          </div>
        </div>
      </div>
      <div class="calendar-bottom">
        <div class="btn" @click="isSelectDate">确定</div>
      </div>
    </van-popup>

    <!--大件货-选日期-->
    <van-popup
        class="popup-express-service-con"
        v-model="calendarLargeShow"
        round
        position="bottom"
        closeable
        close-icon="close"
        :lazy-render="true"
        :style="{ height: '80%' }"
    >
      <div class="header-con">
        <div class="header-title">配送</div>
        <div class="express-con">
          <span class="express">京东快递</span>
        </div>
      </div>
      <div class="sub-header-con">
        <div class="sub-header-title">送货时间</div>
      </div>
      <div class="calendar-large-body">
        <div class="date-con">
          <div class="date-item-con">
            <div class="item"
               v-for="(item, i) in lgDateList"
               :class="{active: (i===lgDateActive)}"
               @click="lgSetDate(i)"
            >
              <span class="show-text" v-html="item.text"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar-bottom">
        <div class="btn" @click="calendarLargeShow=false">确定</div>
      </div>
    </van-popup>

    <!--设置密码-->
    <van-popup
        v-model="setWalletPass"
        :close-on-click-overlay="false"
        get-container="#app"
        :style="{width: '90%', height: '48%'}"
    >
      <set-wallet-pass @setPass="setPass" />
    </van-popup>

  </div>
</template>

<script>
import { getPaySignInfo } from '@/api/pay/payApi'
import { mapGetters } from 'vuex'
import confirmOrderItem from './components/confirmOrderItem/index'
import goodsList from './components/confirmOrderItem/goodsList'
export default {
  components: {
    confirmOrderItem,
    goodsList,
  },
  data(){
    return {
      list: [],
      notGoods: [],//无货数据
      notGoodsShow: false,//无货数据 是否展示
      goodsListShow: false,
      shopItems: [],
      goodsNumberCount: 0,
      address: {},
      notAddress: false,
      calendarShow: false,
      calendarSmallShow: false,
      calendarLargeShow: false,
      small: [],//中小件货的sku
      large: [],//大件货的sku
      //日历数据
      calendarList: [],//小件货日历列表
      calendarTimeList: [],
      calendarShowText: '',//小件货日历展示文字
      calendarListIndex: 0,//小件货日历日期(默认index)
      calendarListTimeIndex: 0,//小件货日历时间段(默认index)
      lgDateList: [],//大件货日历
      lgDateActive: '',//大件货日历-选中index

      calendarSelectDate: 0,//已选数据
      calendarSelectDateTime: 0,//已选数据
      showCalendarSelectText: '',//已选-展示text

      //付款相关：
      canClick: true,
      payPassword: '',//是否拥有密码
      setWalletPass: false,//设置钱包密码
      isDeduct: false,//是否抵扣
    }
  },
  computed:{
    ...mapGetters([
      'notGoodsList',//无货的商品
      'addressListMap',//用户地址列表-map列表
      'addressSelectedId',//已选地址id
      'sgOrderGoodsList',//已选订单
      'calendarListResult',//配送日历-中小件货日历
      'laCalendarListResult',//配送日历-大件货日历
      'skuClassifyResult',//配送日历-大小件货分类
      'salesCheckMap',//是否可售校验
      'sgOrderFreight',//运费
      'sgOrderGoodsCount',//商品总件数
      'sgOrderTotalPrice',//商品总价格
      'Pcoin',//平台金币信息
      'antWallet',//用户金币钱包
      'sgOrderTotalDeductionPrice',//金币可抵扣金额
      'sgOrderTotalDeductionCoin',//金币可抵扣金币数
    ]),
    deductionPrice(){
      return this.$numMulti(this.sgOrderTotalDeductionCoin, this.Pcoin.buyPrice).toFixed(2)
    },
    totalPrice(){
      let price = this.sgOrderTotalPrice + this.sgOrderFreight
      if(this.isDeduct){
        price -= this.deductionPrice
      }
      return price.toFixed(2)
    },
  },
  watch: {
    notGoodsList: {
      handler(data, oldVal) {
        console.log('notGoodsList',data)
        this.notGoods = data
        if(data.length){
          this.notGoodsShow = true
        }else {
          this.notGoodsShow = false
        }
      },
      deep: true,
      immediate: true
    },
    addressSelectedId: {
      handler(val, oldVal) {
        this.address = this.addressListMap[val]
        this.$store.dispatch('sgOrder/initArea', this.address)
      },
      immediate: true
    },
    sgOrderGoodsList: {
      handler(data, oldVal) {
        this.list = data
      },
      deep: true,
      immediate: true
    },
    skuClassifyResult: {
      handler(data, oldVal) {
        console.log('skuClassifyResult', data)
        // console.log('calendarListResult', this.calendarListResult)
        // console.log('laCalendarListResult', this.laCalendarListResult)
        if(!data){return false;}
        let small=[],large=[];//中小件货， 大件货
        let skuClassifyMaps = this.skuClassifyResult.skuClassifyMaps
        for(let key in skuClassifyMaps){
          if(skuClassifyMaps[key]===1){//1：表示中小件，2：表示大家电
            small.push(key)
          }else if(skuClassifyMaps[key]===2){
            large.push(key)
          }
        }
        this.small = small
        this.large = large
        // 中小件货日历
        if(this.calendarListResult!==null){ //中小件货
          console.log(this.calendarListResult)

          this.calendarList = this.calendarListResult.calendarList
          //遍历默认值
          for(let i=0;i<this.calendarList.length;i++){
            let a = '';
            for(let i2=0;i2<this.calendarList[i].timeList.length;i2++){
              if(this.calendarList[i].timeList[i2].selected){
                this.calendarListIndex  = a = i;
                this.calendarListTimeIndex = i2;
                this.calendarTimeList = this.calendarList[i].timeList;

                this.calendarSelectDate = i
                this.calendarSelectDateTime = i2
              }
            }
            if(a!==''){
              break
            }
          }
          //默认显示文字：
          let week = this.weekChinese( this.calendarList[this.calendarListIndex].week )
          let date = this.calendarList[this.calendarListIndex].dateStr
          let time = this.calendarTimeList[this.calendarListTimeIndex].timeRange
          let arr = date.split('-');
          this.showCalendarSelectText = `${arr[1]}月${arr[2]}日 <span class="red">[周${week}]</span> ${time}`;
        }else {//中小件无配送日历
          if(this.small.length>0){
            this.showCalendarSelectText = '工作日、双休日与节假日均可送货'
          }
        }
        // 大件货日历
        if(this.laCalendarListResult!==null){
          console.log(this.laCalendarListResult)

          let reservingDateList = this.laCalendarListResult.reservingDateList || []
          let today = new Date();
          if(reservingDateList.length){
            this.lgDateList = reservingDateList.map(item=>{
              return this.addDate(today, item)
            })
            this.lgDateActive = 0
          }else {
            this.lgDateActive = ''
          }

          console.log('this.lgDateList', this.lgDateList)

        }
      },
      deep: true,
      immediate: true
    },
    Pcoin: {
      handler(newData, oldData) {
        if(!newData.buyPrice){
          this.$store.dispatch('app/getPlatformCoin', {}).then(data=>{
            this.$store.dispatch('sgOrder/setPlatformCoin', data)
          })
        }else {
          this.$store.dispatch('sgOrder/setPlatformCoin', newData)
        }
      },
      deep:true,
      immediate: true
    },
    isDeduct(val){
      this.$store.dispatch('sgOrder/changeIsDeduct', val)
    },

  },

  created(){
    this.$store.dispatch('sgOrder/getAntIntegralWallet', {
      userOpenid: this.session('userOpenId'),
      code:'AntCoin',
      walletType:0
    }).then(data=>{
      let goodslist = JSON.parse( localStorage.getItem('sgOrderGoodsList') ) || []
      if(goodslist.length){
        this.$store.dispatch('my/checkWalletHasPass', {userOpenid: this.session('userOpenId'), walletType:0}).then(res=>{
          this.payPassword = res.data.payPassword
        })
        //获取用户地址
        this.$store.dispatch('my/getAddressList', {openid: this.session('userOpenId')}).then((list)=>{
          if(list.length){
            this.$store.dispatch('sgOrder/initGoodsData', goodslist)
          }else {
            this.notAddress = true
            console.log('无收货地址！')
          }
        })
      }else {
        this.$router.go(-1)
      }
    })
  },
  methods: {
    //获取地址
    goAddressList(){
      let query = {addressSelectedId: (this.addressSelectedId || '')}
      this.$router.push({name: 'addressList', query})
    },
    //展示商品列表
    openGoodsListCon(index){
      this.goodsNumberCount = this.list[index].shopGoodsNumberCount
      this.shopItems = Object.assign([], this.list[index].shopItems)
      this.goodsListShow = true
    },


    //返回上一页
    goPrevPage(){
      this.$router.go(-1)
    },
    //设置地址
    goSettingAddress(){
      this.$router.push({name: 'editAddress'})
    },

    openCalendar(type){
      if(type===1){
        if(this.calendarList.length>0){
          this.calendarSmallShow = true
        }
      }else {
        if(this.lgDateList.length>0){
          this.calendarLargeShow = true
        }
      }
    },

    //打开日历
    openJDCalendar(){
      console.log('this.small: ', this.small)
      console.log('this.large: ', this.large)
      if(this.small.length && this.large.length){//同时存在 大件、中小件 日历
        console.log('同时存在大件与中小件货物')
        this.calendarShow = true
      }else if(this.small.length && !this.large.length){//只存在中小件货
        console.log('只存在中小件货物')
        if(this.calendarList.length>0){
          this.calendarSmallShow = true
        }
      }else if(!this.small.length && this.large.length){//只存在大件货
        console.log('只存在大件货物')
        this.calendarLargeShow = true
      }else { //不可预约配送
        this.calendarShow = true
        console.log('不可预约配送')
      }
    },
    //小件货-选择日期
    selectDate(item, i){
      if(i===this.calendarListIndex){
        this.calendarSelectDateTime = this.calendarListTimeIndex
      }else {
        this.calendarSelectDateTime = -1
      }
      this.calendarSelectDate = i
      this.calendarTimeList = this.calendarList[i].timeList;

    },
    selectDateTime(item2, i2){
      this.calendarSelectDateTime = i2
    },
    //小件货-选定日期
    isSelectDate(){
      if(this.calendarSelectDateTime<0){
        this.$toast('请选择具体送货时间')
        return false
      }
      let week = this.weekChinese( this.calendarList[this.calendarSelectDate].week )
      let date = this.calendarList[this.calendarSelectDate].dateStr
      let time = this.calendarTimeList[this.calendarSelectDateTime].timeRange
      let arr = date.split('-');
      this.showCalendarSelectText = `${arr[1]}月${arr[2]}日 <span class="red">[周${week}]</span> ${time}`;
      this.calendarSmallShow = false
      console.log('date, time: ，showText：', date, time, this.showText)
    },

    // 大件货选定日期
    lgSetDate(i){
      this.lgDateActive = i
    },



    //星期转换
    weekChinese(val){
      let text = ''
      switch (val){
        case 1:
          text = '一'
          break;
        case 2:
          text = '二'
          break;
        case 3:
          text = '三'
          break;
        case 4:
          text = '四'
          break;
        case 5:
          text = '五'
          break;
        case 6:
          text = '六'
          break;
        case 7:
          text = '日'
          break;
        default:
          break
      }
      return text
    },
    //确认下单
    submitOrder(){
      if(this.notGoods.length>0){//存在无货商品
        this.$toast('存在无货商品，请重新选择商品！')
        return false
      }
      if(!this.canClick){//防止重复提交
        return false
      }
      this.canClick = false
      if(this.payPassword!=='1'){//判断是否有密码
        this.setWalletPass = true;
        return false
      }
      let myToast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      let data = {
        jdLogisticsInfo: {},
        userAddressId: this.addressSelectedId
      }
      if(this.calendarList.length>0){//是否有中小件预约
        data.jdLogisticsInfo.promiseDate = this.calendarList[this.calendarSelectDate].dateStr
        data.jdLogisticsInfo.promiseTimeRange = this.calendarList[this.calendarSelectDate].timeList[this.calendarSelectDateTime].timeRange
        data.jdLogisticsInfo.promiseTimeRangeCode = this.calendarList[this.calendarSelectDate].timeList[this.calendarSelectDateTime].timeRangeCode
      }
      if(this.lgDateList.length>0){//是否有大件预约
        data.jdLogisticsInfo.reservingDate = this.lgDateList[this.lgDateActive].days
      }
      if(this.isDeduct){//金币抵扣
        data.integralDeductCashAmount = this.deductionPrice
      }
      this.$store.dispatch('sgOrder/placeGoodsOrder', data).then(res=>{
        let obj = {
          orderId: res.data.orderId,
          orderNo: res.data.orderNo,
          totalAmount: res.data.totalAmount,
          pageFrom: this.$route.fullPath
        }
        this.session('sgConfirmOrderPay', obj)
        this.canClick = true
        this.$toast.clear(myToast)
        localStorage.removeItem('sgOrderGoodsList')
        this.$router.push({name: 'sgConfirmOrderPay'})
      })
    },


    // 子组件 setWalletPass 触发的方法
    setPass(data){
      if(data==='ok'){
        this.payPassword = 1
        this.setWalletPass = false;
        this.submitOrder() //触发下单操作
      }
    },

    addDate(oldDate, days){
      if (days == undefined || days == '') {
        return false
      }
      let date = new Date(oldDate);
      date.setDate(date.getDate() + days);
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let newDate = date.getFullYear() + '-' + this.getFormatDate(month) + '-' + this.getFormatDate(day);
      let weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      let text = `${ this.getFormatDate(month) }月${ this.getFormatDate(day) }日 <span class="red">[${ weeks[new Date(newDate).getDay()] }]</span>`;
      return {date: newDate, text, days }
    },
    getFormatDate(arg) {
      if (arg == undefined || arg == '') {
        return '';
      }
      var re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    }
  }
}
</script>

<style lang="less" scoped>
@url: '../../../assets/my/';
.sg-confirm-order{
  position: relative;width: 100%;height: 100%;overflow: hidden;
  font-size: 14px;
  .main-con{
    position: absolute;left: 0;right: 0;top: 0;bottom: 50px;overflow: auto;
    .addr-con{
      .no-addr{
        display: flex;height: 68px;
        .left-con{
          flex: 1;display: flex;height: 100%;justify-content: flex-start;align-items: center;font-size: 16px;color: #2b2b2b;
          .addr-icon{
            background: url("@{url}sgOrder/add-icon.png") no-repeat 50% 50%;background-size: 100%;
            display: block;width: 18px;height: 18px;margin: 0 12px;
          }
        }
        .right-con{
          width: 32px;height: 100%;
          display: inline-flex;justify-content: center;align-items: center;
          .icon{
            display: block;width: 8px;height: 16px;
            background: url("@{url}icon-right.png") no-repeat 50% 50%;
            background-size: 100%;
          }
        }
      }
      .has-addr{
        min-height: 102px;display: flex;align-items: center;
        .right-icon-con{
          width: 68px;height: 100%;display: inline-flex;justify-content: center;align-items: center;
          .icon{
            width: 44px;height: 44px;display: block;
            background: url("@{url}sgOrder/addr-icon-select.png") no-repeat 50% 50%;background-size: 100%;
          }
        }
        .addr-info{
          flex: 1;height: 100%;padding: 12px;
          display: inline-flex;flex-direction: column;justify-content: center;align-items: flex-start;
          .name-con{
            line-height: 1;padding-bottom: 12px;
            .name{font-size: 13px;color: #333;padding-right: 10px;}
            .phone{font-size: 12px;color: #999;padding-right: 10px;}
            .default{
              font-size: 11px;color: #fff;line-height: 1;padding: 2px 6px;
              background-color: #fba832;border-radius: 6px;
            }
          }
          .address{font-size: 16px;color: #333;}
        }
        .right-con{
          width: 32px;height: 100%;
          display: inline-flex;justify-content: center;align-items: center;
          .icon{
            display: block;width: 8px;height: 16px;
            background: url("@{url}icon-right.png") no-repeat 50% 50%;
            background-size: 100%;
          }
        }
      }
    }
    .express-service, .express-service-time{
      height: 44px;display: flex;
      padding: 0 0 0 12px;color: #333;
      .left-con{
        flex: 1;height: 100%;display: flex;justify-content: space-between;align-items: center;
        .text-con{
          text-align: right;
          .text{line-height: 1;font-size: 12px;}
          .time{padding-bottom: 4px;}
          .date{}
          /deep/ .red{color: rgb(247,77,77);line-height: 1;}
        }
      }
      .right-con{
        width: 32px;height: 100%;
        display: inline-flex;justify-content: center;align-items: center;
        .icon{
          display: block;width: 8px;height: 16px;
          background: url("@{url}icon-right.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
    .deduct-coin{
      display: flex;height: 44px;width: 100%;color: #333;font-size: 14px;
      .left{
        width: 79px;height: 100%;display: inline-flex;justify-content: center;align-items: center;
      }
      .can-deduct{
        font-size: 12px;width: 60px;height: 100%;color: rgb(251,168,50);
        display: inline-flex;justify-content: flex-start;align-items: center;
      }
      .has-coin-con{
        display: inline-flex;justify-content: center;align-items: flex-end;
        font-size: 12px;flex: 1;flex-direction: column;
        .text-item{

        }
      }
      .right{
        display: inline-flex;justify-content: center;align-items: center;
        width: 60px;height: 100%;
      }
    }
    .cell-list{
      .cell{
        display: flex;height: 44px;padding: 0 12px;color: #333;
        border-bottom: 1px solid #eee;
        .left{
          width: 30%;height: 100%;font-size: 14px;
          display: inline-flex;justify-content: flex-start;align-items: center;}
        .right{
          flex: 1;height: 100%;font-size: 13px;
          display: inline-flex;justify-content: flex-end;align-items: center;
        }
      }
    }
  }
  .bottom-con{
    display: flex;height: 50px;border-top: 1px solid #eee;
    position: absolute;left: 0;right: 0;bottom: 0;line-height: 1;
    .goods-count{
      width: 63px;height: 100%;display: inline-flex;justify-content: center;align-items: center;
      font-size: 12px;color: #666;
      .count{display: inline-flex;align-items: flex-end;height: 100%;padding-bottom: 17px;}
    }
    .price-con{
      flex: 1;height: 100%;display: inline-flex;justify-content: flex-start;align-items: center;
      font-size: 12px;color: #333;
      .price{
        display: inline-flex;align-items: flex-end;height: 100%;padding-bottom: 16px;
        .red{
          color: rgb(247,77,77);
          .big{
            font-size: 20px;
          }
        }
      }
    }
    .btn-con{
      width: 159px;height: 100%;
      display: inline-flex;justify-content: center;align-items: center;
      .btn{
        width: 135px;height: 35px;
        font-size: 16px;color: #fff;border-radius: 18px;background-color: #f74d4d;
        display: inline-flex;justify-content: center;align-items: center;
      }
    }

  }

  .not-goods-show{
    .text{font-size: 16px;text-align: center;line-height: 1;padding: 14px 0;}
    .list-con{
      position: absolute;z-index: 0;top: 44px;bottom: 66px;left: 0;right: 0;overflow: auto;padding: 0 20px;
      .list{
        width: 100%;height: 65px;margin-bottom: 10px;display: flex;
        .img-con{
          width: 65px;height: 100%;display: inline-flex;position: relative;
          .img{width: 100%;height: 100%;border-radius: 10px;border: .75px solid rgba(153,153,153,.5)}
          .no-goods{
            position: absolute;width: 100%;height: 100%;
            background: rgba(255,255,255,.2) url("@{url}/shoppingCart/no-stock-img.png") no-repeat 50% 50%;
            background-size: 100%;
          }
        }
        .info-con{
          flex: 1;font-size: 10px;
          display: inline-flex;flex-direction: column;justify-content: space-between;
          .title{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;
            color: rgba(43,43,43, .5);
          }
          .info-bottom{
            display: flex;
            .price-con{
              flex: 1;
              .now-price{color: rgba(247,77,77,.5);padding-right: 8px;}
              .old-price{color: rgba(153,153,153,.5);font-size: 7px;}
            }
            .count{
              color: rgba(51,51,51,.5);
            }
          }
        }
      }
    }

    .btn-con{
      display: flex;align-items: center;justify-content: space-evenly;
      position: absolute;bottom: 0;left: 0;right: 0;padding: 15px 0;
      .btn{
        font-size: 14px;display: inline-flex;justify-content: center;align-items: center;
        width: 115px;height: 36px;border-radius: 16px;
        &.cancel{margin-right: 12px;border: 1px solid #1585f3;color: #1585f3;}
        &.go-setting{border: 1px solid #1585f3;background-color: #1585f3;color: #fff;}
      }

    }
  }

  .not-address{
    width: 279px;padding: 20px;
    .text{font-size: 16px;padding-bottom: 30px;}
    .btn-con{
      display: flex;align-items: center;justify-content: space-evenly;
      .btn{
        width: 113px;font-size: 14px;display: inline-flex;justify-content: center;align-items: center;
        height: 36px;border-radius: 16px;
        &.cancel{margin-right: 12px;border: 1px solid #1585f3;color: #1585f3;}
        &.go-setting{border: 1px solid #1585f3;background-color: #1585f3;color: #fff;}
      }

    }
  }
  .popup-goods-list-con{
    .header-con{
      padding: 0 12px;display: flex;border-bottom: 1px solid #eee;
      .header-title{font-size: 16px;font-weight: bold;color: #333;flex: 1;line-height: 50px;}
      .count{font-size: 12px;color: #666;margin-right: 27px;line-height: 50px;}
    }
    .list-body{
      position: absolute;top: 50px;bottom: 0;left: 0;right: 0;overflow-y: auto;
    }
  }

  .popup-express-service-con{
    .header-con{
      padding: 0 12px;
      .header-title{font-size: 16px;font-weight: bold;color: #333;flex: 1;line-height: 50px;}
      .express-con{
        .express{
          width: 92px;height: 28px;display: inline-flex;justify-content: center;align-items: center;line-height: 1;
          color: #1585f3;border: 1px solid #1585f3;border-radius: 14px;
        }
      }
    }
    .sub-header-con{
      padding: 12px;
      .express-time-con{
        padding: 12px 0;
        .express-time{
          width: 92px;height: 28px;display: inline-flex;justify-content: center;align-items: center;line-height: 1;
          color: #1585f3;border: 1px solid #1585f3;border-radius: 14px;
        }
      }
    }
    .date-con-body{
      padding: 4px 0;
      .list{
        font-size: 13px;padding: 8px 12px;border-bottom: 1px solid #eee;
        &:last-child{border-bottom: none;}
        .title{font-size: 14px;}
      }

    }
    .calendar-body{
      display: flex;
      position: absolute;left: 0;right: 0;bottom: 50px;top: 172px;
      .date-con{
        width: 132px;height: 100%;overflow-x: hidden;
        .date-item-con{
          width: 140px;height: 100%;overflow-y: auto;padding-right: 8px;
          .item{
            width: 100%;height: 46px;background-color: #f2f2f2;color: #666;
            display: flex;justify-content: center;align-items: center;
            &.active{
              color: #1585f3;background-color: #fff;
            }
            .show-text{}
          }
        }
      }
      .time-con{
        flex: 1;padding: 0 12px;height: 100%;overflow: auto;
        .time-item-con{
          .item{
            display: flex;justify-content: center;align-items: center;
            width: 100%;height: 46px;color: #333;font-size: 13px;
            border-radius: 5px;border: 1px solid #dedede;margin-bottom: 10px;
            &.active{
              color: #1585f3;border: 1px solid #1585f3;
            }
          }
        }
      }
    }
    .calendar-bottom{
      width: 100%;height: 50px;
      display: flex;justify-content: center;align-items: center;
      position: absolute;left: 0;right: 0;bottom: 0;
      .btn{
        width: 351px;height: 40px;border-radius: 20px;background-color: #1585f3;
        font-size: 16px;color: #fff;display: flex;justify-content: center;align-items: center;
      }
    }
    .calendar-large-body{
      position: absolute;left: 0;right: 0;bottom: 50px;top: 120px;padding: 0 12px 12px;overflow: auto;
      .date-item-con{
        width: 100%;height: 100%;overflow: auto;
        .item{
          display: flex;justify-content: center;align-items: center;
          width: 100%;height: 46px;color: #333;font-size: 13px;padding-left: 16px;
          border-radius: 5px;border: 1px solid #dedede;margin-bottom: 10px;
          &.active{
            color: #1585f3;border: 1px solid #1585f3;
          }
        }
      }
    }

  }

}
</style>